export default "__VITE_ASSET__h4Lf2poV__"